<template>
    <div>
        {{info}}
    </div>
</template>
<script>
export default {
    props:[
        'info'
    ]
}
</script>